import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

interface OptionButtonProps {
  isSelected: boolean;
  onClick: () => void;
  icon?: IconProp;
  label: string;
}

export const OptionButton = ({
  isSelected,
  onClick,
  icon,
  label,
}: OptionButtonProps) => (
  <button
    className={`
      px-3 py-2 rounded-lg text-sm text-nowrap transition transform duration-150
      ${isSelected
        ? 'bg-ptTeal hover:bg-ptTeal-100 text-white '
        : 'bg-gray-200 hover:bg-gray-300 text-gray-700 hover:text-gray-600 hover:scale-105 active:scale-95'
      }
    `}
    onClick={onClick}
  >
    {icon
      ? <FontAwesomeIcon icon={icon} className={"mr-2"} />
      : null
    }
    {label}
  </button>
)
